import { cn } from '@/utils/cn';

export const YouTubeLogo = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={cn('w-6', className)}
			viewBox="0 0 24 24"
			fill="currentColor"
		>
			<path d="M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502a2.856 2.856 0 0 1-2.01 2.019C17.896 20 12 20 12 20s-5.893 0-7.533-.479a2.856 2.856 0 0 1-2.01-2.019C2 15.72 2 12 2 12s0-3.72.457-5.502a2.857 2.857 0 0 1 2.01-2.019C6.107 4 12 4 12 4s5.896 0 7.533.479a2.857 2.857 0 0 1 2.01 2.019zM10 15.5l6-3.5-6-3.5v7z" />
		</svg>
	);
};
